import * as React from "react";
import { Loader2 } from "lucide-react";

import type { VersionInfo } from "../documentAuthoring.types";

interface Props {
  pendingVersion: VersionInfo;
}

/** Shown while a saved version is still being ingested (D10); the drive row mirrors it. */
export const ProcessingBanner: React.FC<Props> = ({ pendingVersion }) => (
  <div
    role="status"
    className="flex items-center gap-2 border-b border-amber-200 bg-amber-50 px-4 py-2 text-xs text-amber-900"
  >
    <Loader2 className="h-4 w-4 animate-spin" aria-hidden="true" />
    Version {pendingVersion.version_no} is being processed. Q&amp;A and SnapShots keep using the previous version until
    it completes.
  </div>
);
